<link rel="stylesheet" href="https://cdn.jsdelivr.net/gh/openlayers/openlayers.github.io@master/en/v6.5.0/css/ol.css"
  type="text/css">
<div id="map" class="map" [class.mapbox-terrain-active]="isMapboxTerrainMode">

<!-- Tooltip pour drag & drop de route -->
<div id="drag-tooltip" class="drag-tooltip" *ngIf="dragTooltipVisible" [style.left.px]="dragTooltipX" [style.top.px]="dragTooltipY">
  {{ dragTooltipText }}
</div>

<div id="mapbox-container" *ngIf="isMapboxTerrainMode"></div>
<div class="mapbox-loading-overlay" *ngIf="isMapboxTerrainMode && !mapboxReady">
  <div class="mapbox-spinner"></div>
  <span>Chargement de la vue 3D...</span>
</div>

<!-- Le terrain du site peut être long à télécharger puis à décoder : sans ça
     on attendait devant un écran noir. Volontairement translucide pour laisser
     voir les trous et terrains blast qui s'affichent pendant ce temps. -->
<div class="site-terrain-loading" *ngIf="isMapboxTerrainMode && mapboxReady && siteTerrainLoading()">
  <div class="mapbox-spinner"></div>
  <span>Chargement du terrain du site...</span>
</div>

<div class="bottom-right-widgets" [ngClass]="{'expanded': !referentielOuvert}" *ngIf="!isMapboxTerrainMode">
  <div id="holeStatus-legend" *ngIf="showLegend && ((holeLegendProperties.length > 0 && selectedHoleFeatureFilter === 'all') || (holeFeatureLegendProperties.length > 0 && selectedHoleFeatureFilter !== 'all')) && holesAreShown">
  <!-- Status Legend Grid -->
  <div class="holeLegendGrid" [ngClass]="{'filtered-grid': holeLegendProperties[0]?.percentage !== undefined}" *ngIf="selectedHoleFeatureFilter === 'all'">
    <div class="holeLegendBox" *ngFor="let legend of holeLegendProperties; let i = index">
      <img [src]="getHoleIconForLegend(legend.holeStatus)" 
     [alt]="legend.holeStatus" 
     class="hole-status-icon">
      <div class="legend-text">
        <p *ngIf="legend.percentage !== undefined">{{ 'HOLE.' + legend.holeStatus | translate }} - {{ legend.percentage }}%</p>
        <p *ngIf="legend.percentage === undefined">{{ 'HOLE.' + legend.holeStatus | translate }} ({{ legend.numberOfHoles }})</p>
        <small *ngIf="legend.percentage !== undefined">{{ legend.numberOfHoles }}/{{ legend.totalHoles || 0 }} holes</small>
      </div>
    </div>
  </div>
  <!-- Feature Legend Grid -->
  <div class="holeLegendGrid" [ngClass]="{'filtered-grid': holeFeatureLegendProperties[0]?.percentage !== undefined}" *ngIf="selectedHoleFeatureFilter !== 'all'">
    <div class="holeLegendBox" *ngFor="let legend of holeFeatureLegendProperties; let i = index">
      <img [src]="getFeatureIconPath(legend.featureType)" 
     [alt]="legend.featureType" 
     class="hole-status-icon">
      <div class="legend-text">
        <p *ngIf="legend.percentage !== undefined">{{ getFeatureDisplayName(legend.featureType) }} - {{ legend.percentage }}%</p>
        <p *ngIf="legend.percentage === undefined">{{ getFeatureDisplayName(legend.featureType) }} ({{ legend.numberOfHoles }})</p>
        <small *ngIf="legend.percentage !== undefined">{{ legend.numberOfHoles }}/{{ legend.totalHoles || 0 }} holes</small>
      </div>
    </div>
  </div>
</div>

<div id="mouse-position"></div>


</div>

  <div id="custom-scale-line" class="custom-scale-line" *ngIf="!isMapboxTerrainMode">
    <span id="scale-text">100 m</span>
    <div id="scale-bar" class="scale-bar"></div>
  </div>
  <!-- app.component.html -->
  
  
  
<!-- Trois modes exclusifs : un seul actif à la fois -->
<div class="top-right-buttons">
  <button type="button" class="icon-carto" [ngClass]="{'active': viewMode === 'map2d'}"
      (click)="this.layerSwitch(3);">
     <img src="assets/icon/map.svg" alt="" />
      <div class="btn-label">Map</div>
    </button>
    <button type="button" class="icon-carto" [ngClass]="{'active': viewMode === 'plan2d'}"
      (click)="this.layerSwitch(2);">
      <img src="assets/icon/Flat_map.svg" alt="" />
      <div class="btn-label">Plan</div>
    </button>
    <button type="button" class="icon-carto" [ngClass]="{'active': viewMode === '3d'}"
      (click)="this.layerSwitch(4);">
      <img src="assets/icon/3D.svg" alt="" />
      <div class="btn-label">3D</div>
    </button>

</div>

<!-- Panneau upload LAZ en mode 3D -->
<div class="laz-upload-panel" *ngIf="isMapboxTerrainMode">
  <label class="laz-upload-btn">
    <i class="fas fa-cloud-upload-alt"></i>
    <span>Upload LAZ/LAS</span>
    <input type="file" accept=".laz,.las" (change)="onLazFileSelected($event)" hidden />
  </label>
  <div class="laz-info" *ngIf="lazFileName()">
    <span class="laz-filename">{{ lazFileName() }}</span>
    <span class="laz-points" *ngIf="lazPointCount() > 0">{{ lazPointCount() | number }} pts</span>
  </div>
  <div class="laz-progress" *ngIf="lazIsLoading()">
    <div class="laz-progress-bar" [style.width.%]="lazLoadingProgress()"></div>
    <span class="laz-progress-text">{{ lazLoadingProgress() }}%</span>
  </div>
</div>

<app-treeview id="treeeview-container" [ngClass]="referentielOuvert ? 'display-div': 'hidden-div'"
    (selectedTirs)="getTirChange($event)" (selectedKPI)="getSelectedKPI($event)" (centrerTir)="getCentrerTir($event)"
    [selectionActivee]="true" [listeTirs]="listeTirs()" [listeDonneesAnalyse]="kpiSelectionne" [defaultKPI]="defaultKPI"
    [popupOuverte]="popupOuverte.asObservable()" [popupFermee]="popupFermee.asObservable()">
  </app-treeview>
  <div [ngClass]="referentielOuvert ? 'display-chevron': 'hidden-chevron'" (click)="inverserReferentielOuvert()">
    <i *ngIf="referentielOuvert" class="fas fa-chevron-left"></i>
    <i *ngIf="!referentielOuvert" class="fas fa-chevron-right"></i>
  </div>

  <div class="right-menu" *ngIf="!isMapboxTerrainMode">
    <div class="top-buttons-container" #topButtonsContainer [ngClass]="{'top-scroll': isTopButtonsOverflow}">
      <button type="button" class="icon-button ruler-btn" [ngClass]="{'active': activeButton === 2}" title="Measure line"
        (click)="setActiveButton(2)">
        <img src="assets/icon/Ruler.svg" alt="" />
        <div class="right-menu-btn-label ">{{ 'GLOBAL.RULER' | translate }}</div>
        <div class="tooltip-custom">{{ 'GLOBAL.MEASURE_TOOL' | translate }}</div>
      </button>
      <div class="button-separator"></div>
      <button type="button"
          class="icon-button polygon-btn"
          [ngClass]="{'active': activeButton === 3}"
          (click)="setActiveButton(3)"
         >
        <img class="icon-default" src="assets/icon/Polygon_right.svg" alt="" />
        <img class="icon-active" src="assets/icon/Polygon_focus.svg" alt="" />
        <div class="right-menu-btn-label">{{ 'POLYGON.POLYGON' | translate }}</div>
      <div class="tooltip-custom">{{ 'GLOBAL.POLYGON_CREATE_TOOL' | translate }}</div>
    </button>
    <div class="button-separator"></div>
    <button type="button"
        class="icon-button zoi-btn"
        [ngClass]="{'active': activeButton === 4}"
        (click)="startZOIDrawing()"
       >
      <img src="assets/icon/Polygon_right.svg" alt="" />
      <div class="right-menu-btn-label">{{ 'ZOI.ZONE' | translate }}</div>
      <div class="tooltip-custom">{{ 'ZOI.CREATE_TOOL' | translate }}</div>
    </button>

    <!-- MODALE ZOI TYPE (circle or polygon) -->
    <div *ngIf="showZoiTypeModal" class="modal-overlay-polygon-type">
      <div class="modal-body">
        <div class="polygon-type-options">
          <button type="button" class="polygon-type-btn" (click)="selectAndStartZOIType('normal')">
            <img src="assets/icon/line.svg" alt="" />
            <span>{{ 'POLYGON.POLYGON' | translate }}</span>
          </button>
          <button type="button" class="polygon-type-btn" (click)="selectAndStartZOIType('circle')">
            <img src="assets/icon/circle.svg" alt="" />
            <span>Circle</span>
          </button>
        </div>
      </div>
    </div>

    <!-- MODALE POLYGON TYPE -->
    <div *ngIf="showPolygonTypeModal" class="modal-overlay-polygon-type">
      <div class="modal-body">
        <div class="polygon-type-options">
          <button 
            type="button" 
            class="polygon-type-btn"
            [ngClass]="{'active': selectedPolygonType === 'normal'}"
            (click)="selectAndStartPolygonType('normal')">
            <img src="assets/icon/line.svg" alt="" />
            <span>Line</span>
          </button>
          
          <button 
            type="button" 
            class="polygon-type-btn"
            [ngClass]="{'active': selectedPolygonType === 'circle'}"
            (click)="selectAndStartPolygonType('circle')">
            <img src="assets/icon/circle.svg" alt="" />
            <span>Circle</span>
          </button>
        </div>
      </div>
    </div>
    
    </div>
  <div class="right-menu-bottom" *ngIf="!isBottomButtonsOverflow">
      <button type="button" class="icon-button-bottom" [ngClass]="{'active': bottomActiveButoon === 1}"
        (click)="setActiveBottomButton(1)">
          <img src="assets/icon/Polygon.svg" alt="" />
          <div class="tooltip-custom">{{ 'TOOLTIP.KPI' | translate }}</div>
      </button>
      <button type="button" class="icon-button-bottom" [ngClass]="{'active': bottomActiveButoon === 2}"
        (click)="setActiveBottomButton(2)">
          <img src="assets/icon/Holes.svg" alt="" />
          <div class="tooltip-custom">{{ 'TOOLTIP.HOLES' | translate }}</div>
      </button>
      <button
        type="button"
        class="icon-button-bottom"
        [ngClass]="{'active': bottomActiveButoon === 3}"
        (click)="setActiveBottomButton(3)"
        [disabled]="!showEquipmentButton"
        > 
        <img src="assets/icon/icon-park_truck.svg" alt="" />
        <div class="tooltip-custom">{{ 'TOOLTIP.EQUIPMENT' | translate }}</div>
      </button>
      <button type="button" class="icon-button-bottom" [ngClass]="{'active': bottomActiveButoon === 4}" 
        (click)="setActiveBottomButton(4)" >
         <img src="assets/icon/ortho.svg" alt="" />
         <div class="tooltip-custom">{{ 'TOOLTIP.ORTHOPHOTO' | translate }}</div>
      </button>
      <button type="button" class="icon-button-bottom" [ngClass]="{'active': bottomActiveButoon === 5}"
        (click)="setActiveBottomButton(5)">
         <img src="assets/icon/Filter.svg" alt="" />
         <div class="tooltip-custom">{{ 'TOOLTIP.FILTER' | translate }}</div>
      </button>
      <button type="button" class="icon-button-bottom" [ngClass]="{'active': bottomActiveButoon === 6}"
        (click)="setActiveBottomButton(6)">
         <img src="assets/icon/Polygon.svg" alt="" />
         <div class="tooltip-custom">{{ 'TOOLTIP.DXF' | translate }}</div>
      </button>
    </div>

  <div class="right-menu-bottom overflow" *ngIf="isBottomButtonsOverflow">
      <button class="nav-arrow-up" 
          (click)="scrollUp()">
            <img src="assets/icon/arraw-up.svg" alt="Scroll up"/>
        </button>
      
  <div class="bottom-button-container" #bottomButtonsContainer [style.max-height.px]="bottomButtonsViewportHeight" [style.height.px]="bottomButtonsViewportHeight">
        <button type="button" 
                class="icon-button-bottom" 
                [ngClass]="{'active': bottomActiveButoon === 1}"
                (click)="setActiveBottomButton(1)">
          <img src="assets/icon/Polygon.svg" alt="" />
          <div class="tooltip-custom">{{ 'TOOLTIP.KPI' | translate }}</div>
        </button>

        <button type="button" 
                class="icon-button-bottom" 
                [ngClass]="{'active': bottomActiveButoon === 2}"
                (click)="setActiveBottomButton(2)">
          <img src="assets/icon/Holes.svg" alt="" />
          <div class="tooltip-custom">{{ 'TOOLTIP.HOLES' | translate }}</div>
        </button>
        
        <button type="button" 
                class="icon-button-bottom"
                [ngClass]="{'active': bottomActiveButoon === 3}"
                (click)="setActiveBottomButton(3)"
                [disabled]="!showEquipmentButton">
          <img src="assets/icon/icon-park_truck.svg" alt="" />
          <div class="tooltip-custom">{{ 'TOOLTIP.EQUIPMENT' | translate }}</div>
        </button>
        
        <button type="button" 
                class="icon-button-bottom"
                [ngClass]="{'active': bottomActiveButoon === 4}"
                (click)="setActiveBottomButton(4)"
                >
          <img src="assets/icon/ortho.svg" alt="" />
          <div class="tooltip-custom">{{ 'TOOLTIP.ORTHOPHOTO' | translate }}</div>
        </button>
        
        <button type="button"
                class="icon-button-bottom"
                [ngClass]="{'active': bottomActiveButoon === 5}"
                (click)="setActiveBottomButton(5)">
          <img src="assets/icon/Filter.svg" alt="" />
          <div class="tooltip-custom">{{ 'TOOLTIP.FILTER' | translate }}</div>
        </button>

        <button type="button"
                class="icon-button-bottom"
                [ngClass]="{'active': bottomActiveButoon === 6}"
                (click)="setActiveBottomButton(6)">
          <img src="assets/icon/Polygon.svg" alt="" />
          <div class="tooltip-custom">{{ 'TOOLTIP.DXF' | translate }}</div>
        </button>
      </div>
      
         <button class="nav-arrow-down" 
          (click)="scrollDown()">
            <img src="assets/icon/arraw-down.svg" alt="Scroll down"/>
        </button>

    </div>
  </div>
  
  <div *ngIf="bottomActiveButoon === 1 && !isMapboxTerrainMode" class="modal-overlay-custome-kpi-scale" [ngClass]="{'full-scroll': isBottomButtonsOverflow}">
    <div class="modal-body kpi-scale-body">
          <div class="header">
          <img src="assets/icon/Polygon_right.svg" alt="" />
        <span class="title">{{ 'POLYGON.POLYGON' | translate }}</span>
        </div>
        <div *ngIf="getZonesWithColors().length > 0" class="filter-item">
          <div class="color-mode-selector">
            <div class="radio-option">
              <label class="radio-label">
                <input type="radio" name="colorMode" [value]="false" 
                       [(ngModel)]="useZoneColors" 
                       (change)="onColorModeChange(false)" />
                <span class="radio-custom"></span>
                <span class="filter-label">KPI</span>
              </label>
            </div>
            <div class="radio-option">
              <label class="radio-label">
                <input type="radio" name="colorMode" [value]="true" 
                       [(ngModel)]="useZoneColors" 
                       (change)="onColorModeChange(true)" />
                <span class="radio-custom"></span>
                <span class="filter-label">{{ 'GLOBAL.ZONES' | translate }}</span>
              </label>
            </div>
          </div>
        </div>

        <!-- Sélecteur KPI (masqué si couleurs par zones activées) -->
        <ng-select *ngIf="!useZoneColors" id="selectKPI" name="selectKPI" [(ngModel)]="selectedKPI" [clearable]="false" (change)="getSelectedKPI($event)"
          [searchable]="false" placeholder="KPI">
          <ng-option *ngFor="let option of listeKPIActifs" [value]="option">{{option.nom }}</ng-option>
        </ng-select>
        
        <!-- Jauge KPI (masquée si couleurs par zones activées) -->
        <div *ngIf="!useZoneColors" id="kpi-jauge">
          <canvas id="scale"></canvas>
          <div class="kpi-bornes">
            <span id="borne-inf" *ngIf="this.showValKPITir">{{borneInf}} {{valKPITir().unite}}</span>
            <span id="borne-sup" *ngIf="this.showValKPITir">{{borneSup}} {{valKPITir().unite}}</span>
          </div>
        </div>

        <div *ngIf="useZoneColors" class="color-content-separator"></div>

  <!-- Légende des zones (affichée si couleurs par zones activées) -->
  <div *ngIf="useZoneColors" class="zones-legend">
          <div class="zone-legend-item" 
               *ngFor="let zoneWithColor of getZonesWithColors(); let last = last" 
               style="display: flex; align-items: center; margin: 5px 0;">
            <div class="zone-color-indicator" [style.background-color]="zoneWithColor.color" 
                 style="width: 16px; height: 16px; border-radius: 3px; margin-right: 8px; border: 1px solid #ccc;"></div>
            <span style="font-size: 13px;">{{zoneWithColor.zone.nomZone}}</span>
            <div *ngIf="!last" class="zone-separator"></div>
          </div>
          </div>
        </div>
      </div>

  <div *ngIf="bottomActiveButoon === 2 && !isMapboxTerrainMode" class="modal-overlay-custome-holes" [ngClass]="{'full-scroll': isHolesModalOverflow}">
  <div class="modal-body holes-body">
    <div class="header">
      <img src="assets/icon/Holes.svg" alt="" />
      <span class="title">{{ 'GLOBAL.HOLES_LEGEND' | translate }}</span>
    </div>

    <!-- Onglets -->
    <div class="tabs">
      <button [class.active]="activeTab === 'state'" (click)="activeTab = 'state'">
        State
      </button>
      <button [class.active]="activeTab === 'feature'" (click)="activeTab = 'feature'">
        Feature
      </button>
    </div>

    <!-- Contenu de l'onglet State -->
    <div *ngIf="activeTab === 'state'" class="holes-legend">
      <div class="hole-legend-item">
        <div class="hole-status-controls">
          <label class="radio-control">
            <input type="radio" 
                   name="holeStatusFilter"
                   value="actual"
                   [checked]="selectedHoleStatusFilter === 'actual'" 
                   (change)="onHoleStatusFilterChange('actual')" />
            <span class="radio-mark"></span>
          </label>
          <span class="hole-status-indicator all-holes"></span>
          <span class="hole-status-text">
            {{ 'GLOBAL.ACTUAL_HOLES' | translate }}
          </span>
        </div>
      </div>

      <div class="hole-legend-item" *ngFor="let status of getHoleStatusList()">
        <div class="hole-status-controls">
          <label class="radio-control">
            <input type="radio" 
                   name="holeStatusFilter"
                   [value]="status"
                   [checked]="selectedHoleStatusFilter === status" 
                   (change)="onHoleStatusFilterChange(status)" />
            <span class="radio-mark"></span>
          </label>
          <img [src]="getHoleIconForLegend(status)" 
               [alt]="status" 
               class="hole-status-icon">
          <span class="hole-status-text">
            {{ 'HOLE.' + status | translate }}
          </span>
        </div>
      </div>
    </div>

    <!-- Contenu de l'onglet Feature -->
    <div *ngIf="activeTab === 'feature'" class="holes-legend">
      <!-- Option pour tous les trous -->
      <div class="hole-legend-item">
        <div class="hole-status-controls">
          <label class="radio-control">
            <input type="radio" 
                   name="holeFeatureFilter"
                   value="all"
                   [checked]="selectedHoleFeatureFilter === 'all'" 
                   (change)="onHoleFeatureFilterChange('all')" />
            <span class="radio-mark"></span>
          </label>
          <span class="hole-status-indicator all-holes"></span>
          <span class="hole-status-text">
            Tous les trous
          </span>
        </div>
      </div>

      <!-- Water -->
      <div class="hole-legend-item">
        <div class="hole-status-controls">
          <label class="radio-control">
            <input type="radio" 
                   name="holeFeatureFilter"
                   value="water"
                   [checked]="selectedHoleFeatureFilter === 'water'" 
                   (change)="onHoleFeatureFilterChange('water')" />
            <span class="radio-mark"></span>
          </label>
            <img src="assets/icon/hole-water.svg" alt="Water" class="feature-icon" />
          <span class="hole-status-text">
            Water
          </span>
        </div>
      </div>

      <!-- Tube -->
      <div class="hole-legend-item">
        <div class="hole-status-controls">
          <label class="radio-control">
            <input type="radio" 
                   name="holeFeatureFilter"
                   value="tube"
                   [checked]="selectedHoleFeatureFilter === 'tube'" 
                   (change)="onHoleFeatureFilterChange('tube')" />
            <span class="radio-mark"></span>
          </label>
            <img src="assets/icon/hole-tube.svg" alt="Tube" class="feature-icon" />
          <span class="hole-status-text">
            Tube
          </span>
        </div>
      </div>
      <!-- Deviation -->
       <div class="hole-legend-item">
        <div class="hole-status-controls">
          <label class="radio-control">
            <input type="radio" 
                   name="holeFeatureFilter"
                   value="deviation"
                   [checked]="selectedHoleFeatureFilter === 'deviation'" 
                   (change)="onHoleFeatureFilterChange('deviation')" />
            <span class="radio-mark"></span>
          </label>
          <img src="assets/icon/hole-deviation.svg" alt="Deviation" class="feature-icon" />
          <span class="hole-status-text">
            Deviation
          </span>
        </div>
      </div>
    </div>

  </div>
</div>
<div *ngIf="bottomActiveButoon === 4 && !isMapboxTerrainMode" class="modal-overlay-custome-ortho" [ngClass]="{'full-scroll': isBottomButtonsOverflow}">
  <div class="modal-body ortho-body">
    <div class="header">
      <img src="assets/icon/ortho.svg" alt="" />
      <span class="title">Orthophoto</span>
    </div>
    
    <!-- Bouton Ajouter -->
    <div class="ortho-add-section" *showIfHasRole="['sys_admin', 'manage_site']">
      <button type="button" 
              class="btn btn-primary btn-add-ortho" 
              (click)="openAddOrthophotosModal()">
        <i class="fas fa-plus" style="margin-right: 8px;"></i>
        {{ 'GLOBAL.AJOUTER' | translate }}
      </button>
    </div>

    <div class="ortho-list" 
         cdkDropList 
         (cdkDropListDropped)="dropOrthoLayer($event)"
         #orthoListContainer
         *ngIf="orthoLayers.length > 0">
      
      <div class="ortho-card" 
           *ngFor="let layer of orthoLayers; let i = index"
           cdkDrag
           [cdkDragBoundary]="orthoListContainer"
           [ngClass]="{ 'active': layer.isVisible }">
        
        <div class="order-indicator">
          <button
            type="button"
            class="arrow up"
            (mousedown)="$event.stopPropagation()"
            (touchstart)="$event.stopPropagation()"
            (click)="moveUp(layer.zOrder)"
            [disabled]="layer.zOrder === 1"
            aria-label="Monter">
          </button>

          <span class="idx">{{ layer.zOrder }}</span>

          <button
            type="button"
            class="arrow down"
            (mousedown)="$event.stopPropagation()"
            (touchstart)="$event.stopPropagation()"
            (click)="moveDown(layer.zOrder)"
            [disabled]="layer.zOrder === orthoLayers.length"
            aria-label="Descendre">
          </button>
        </div>
        
        <div class="ortho-content" 
             cdkDragHandle
             [class.visible]="layer.isVisible">
          <div class="ortho-preview">
            <img src="assets/icon/ortho.svg" [alt]="layer.mapName || 'Orthophoto'" />
          </div>
          <div class="ortho-name" [title]="layer.mapName || ('Couche ' + (i + 1))">
            {{ layer.mapName || ('Couche ' + (i + 1)) }}
          </div>
          <div class="ortho-info">
            <p class="ortho-date" *ngIf="layer.creationDate">{{ layer.creationDate | date: 'dd/MM/yyyy' }}</p>
          </div>
          
          <div class="delete-ortho" 
               (click)="deleteOrthoLayer(layer)" 
               title="Supprimer cette couche"
               *showIfHasRole="['sys_admin', 'manage_site']">
            <img src="assets/icon/delete.svg" alt="Supprimer" />
          </div>
          
          <div class="visibility-toggle">
            <label class="checkbox">
              <input type="checkbox" 
                    [checked]="layer.isVisible"
                    (change)="toggleOrthoLayer(layer)" />
              <span></span>
            </label>
          </div>

        </div>
      </div>
    </div>
    
    <div class="ortho-empty" *ngIf="orthoLayers.length === 0">
      <p class="ortho-empty-title">{{ 'ORTHOPHOTOS.ERREUR_NOT_FOUND' | translate }}</p>
    </div>
  </div>
</div>

<!-- Panneau DXF : visibilité des couches du site -->
<div *ngIf="bottomActiveButoon === 6" class="modal-overlay-custome-ortho" [ngClass]="{'full-scroll': isBottomButtonsOverflow}">
  <div class="modal-body ortho-body">
    <div class="header">
      <img src="assets/icon/Polygon.svg" alt="" />
      <span class="title">DXF</span>
    </div>

    <!-- Bouton Ajouter -->
    <div class="ortho-add-section" *showIfHasRole="['sys_admin', 'manage_site']">
      <button type="button"
              class="btn btn-primary btn-add-ortho"
              (click)="openAddDxfModal()">
        <i class="fas fa-plus" style="margin-right: 8px;"></i>
        {{ 'GLOBAL.AJOUTER' | translate }}
      </button>
    </div>

    <div class="ortho-list" *ngIf="dxfLayers.length > 0">
      <div class="ortho-card"
           *ngFor="let layer of dxfLayers; let i = index"
           [ngClass]="{ 'active': layer.isVisible }">

        <div class="ortho-content" [class.visible]="layer.isVisible">
          <div class="ortho-preview">
            <img src="assets/icon/Polygon.svg" [alt]="layer.name || 'DXF'" />
          </div>
          <div class="ortho-name" [title]="layer.name || ('DXF ' + (i + 1))">
            {{ layer.name || ('DXF ' + (i + 1)) }}
          </div>

          <div class="visibility-toggle">
            <label class="checkbox">
              <input type="checkbox"
                    [checked]="layer.isVisible"
                    (change)="toggleDxfLayer(layer)" />
              <span></span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="ortho-empty" *ngIf="dxfLayers.length === 0">
      <p class="ortho-empty-title">{{ 'DXF.NOT_FOUND' | translate }}</p>
    </div>
  </div>
</div>
  <div *ngIf="bottomActiveButoon === 5" class="modal-overlay-custom-filter">
      <div class="modal-body">
        <div class="header">
          <img src="assets/icon/Filter.svg" alt="" />
          <span class="title">{{ 'TREEVIEW.FILTRER' | translate }}</span>
        </div>
        <div class="filter-item">
          <label class="toggle-switch">
            <input type="checkbox" [(ngModel)]="holeToggle"
            (change)="onHolesToggleChange()" />
            <span class="slider"></span>
          </label>
            <img src="assets/icon/Holes.svg" alt="" />
            <span class="filter-label">{{ 'GLOBAL.TROUS' | translate }}</span>
        </div>
        <div class="filter-item">
          <label class="toggle-switch">
            <input type="checkbox" [ngModel]="cartSelectedTirsPolygoneEnum.includes(PolyEnum.AUTOMATIC)"
            (ngModelChange)="toggleEnumValue(PolyEnum.AUTOMATIC)" />
            <span class="slider"></span>
          </label>
            <img src="assets/icon/Polygon.svg" alt="" />
            <span class="filter-label">Automatic</span>
        </div>
        <div class="filter-item">
          <label class="toggle-switch">
            <input type="checkbox"   
            [ngModel]="cartSelectedTirsPolygoneEnum.includes(PolyEnum.DRILLED)"
            (ngModelChange)="toggleEnumValue(PolyEnum.DRILLED)" />
            <span class="slider"></span>
          </label>
            <img src="assets/icon/Polygon_drilled.svg" alt="" />
            <span class="filter-label">Drilled</span>
        </div>
        <div class="filter-item">
          <label class="toggle-switch">
            <input type="checkbox" 
            [ngModel]="cartSelectedTirsPolygoneEnum.includes(PolyEnum.MUCKPILE)"
            (ngModelChange)="toggleEnumValue(PolyEnum.MUCKPILE)" />
            <span class="slider"></span>
          </label>
            <img src="assets/icon/Polygon_muck.svg" alt="" />
            <span class="filter-label">Muckpile</span>
        </div>
        <div class="filter-item">
          <label class="toggle-switch">
            <input type="checkbox"
             [ngModel]="cartSelectedTirsPolygoneEnum.includes(PolyEnum.DANGER_ZONE)"
            (ngModelChange)="toggleEnumValue(PolyEnum.DANGER_ZONE)" />
            <span class="slider"></span>
          </label>
            <img src="assets/icon/Polygon_danger.svg" alt="" />
            <span class="filter-label">Danger zone</span>
        </div>
        <!-- L'orthophoto est un calque 2D : sans objet en 3D -->
        <div class="filter-item" *ngIf="viewMode !== '3d'">
          <label class="toggle-switch">
            <input type="checkbox"
             [ngModel]="this.mapLayersControler.isOrthoLayerVisible"
             [ngClass]="{'active': this.mapLayersControler.isOrthoLayerVisible }"
            (ngModelChange)="this.layerSwitch(1)" />
            <span class="slider"></span>
          </label>
            <img src="assets/icon/ortho.svg" alt="" />
            <span class="filter-label">Ortho</span>
        </div>
         <div class="filter-item">
          <label class="toggle-switch">
            <input type="checkbox"
                   [(ngModel)]="controlPointsToggle"
                   (ngModelChange)="onControlPointsToggleChange()" />
            <span class="slider"></span>
          </label>
            <img src="assets/icon/control-point-black.svg" alt="" />
            <span class="filter-label">Control points</span>
        </div>
        <div class="filter-item">
          <label class="toggle-switch">
            <input type="checkbox"
                   [(ngModel)]="zoiToggle"
                   (ngModelChange)="onZoiToggleChange()" />
            <span class="slider"></span>
          </label>
            <img src="assets/icon/Polygon_right.svg" alt="" />
            <span class="filter-label">{{ 'ZOI.ZONE' | translate }}</span>
        </div>

      </div>
  </div>


  <div id="popup" class="ol-popup">
    <i class="fa-solid fa-xmark ol-popup-closer" (click)="closePopup()"></i>
    <div *ngIf="popupTirActive()" id="popup-content">
      <h4 style="text-align: center;">
        {{ tirPopup()?.nom?.length > 20 ? (tirPopup()?.nom | slice:0:20) + '...' : tirPopup()?.nom }}
      </h4>
    
      <div *ngIf="tirPopup()?.dateTirPrevisionnelle || tirPopup()?.dateTirEffective">
        <p *ngIf="tirPopup()?.dateTirPrevisionnelle">
          <strong>{{'TIR.DATE_PREV' | translate}} :</strong> {{tirPopup()?.dateTirPrevisionnelle | date: 'dd/MM/yyyy'}}
        </p>
        <p *ngIf="tirPopup()?.dateTirEffective">
          <strong>{{'TIR.DATE_EFF' | translate}} :</strong> {{ (tirPopup()?.dateTirEffective | date: 'dd/MM/yyyy H') + 'h' }}
        </p>
      </div>
    
      <div *ngIf="tirPopup()?.nomZone || tirPopup()?.niveau">
        <p *ngIf="tirPopup()?.nomZone">
          <strong>{{'GLOBAL.ZONE' | translate}} :</strong> {{tirPopup()?.nomZone}}
        </p>
        <p *ngIf="tirPopup()?.niveau">
          <strong>{{'GLOBAL.NIVEAU' | translate}} :</strong> {{tirPopup()?.niveau}}
        </p>
      </div>
    
      <div *ngIf="kpiSelectionne && valKPITir()?.valeur">
        <p>
          <strong>{{'KPI.KPI_SELECTIONNE' | translate}} :</strong> {{kpiSelectionne?.nom}} :
          {{valKPITir().valeur}} {{valKPITir().unite}}
        </p>
      </div>

      <div *ngIf="kpiConfiguration()?.length">
        <div *ngFor="let kpi of kpiConfiguration()">
          <p *ngIf="kpi?.nom && kpi?.valeur">
            <strong>{{kpi?.nom}} :</strong> {{kpi?.valeur}} {{kpi?.unite}}
          </p>
        </div>
      </div>
    
      <div class="popup-footer" style="text-align: left;">
        <a *ngIf="tirPopup()?.projetId"
          [routerLink]="['/mysite', utilService.currentSite()?.siteId, 'myprojects', tirPopup().projetId]"
          [queryParams]="{blastId: tirPopup().tirId}" title="{{'TIR.DETAILS' | translate}}">
          {{'TIR.DETAILS' | translate}}
        </a>
        <a class="create-polygon-btn" (click)="setActiveButton(3)">
          {{'POLYGON.CREATE_POLYGON' | translate}}
        </a>
      </div>
      <div *ngIf="selectedPolygonType === 2 || selectedPolygonType === 3" class="popup-delete-polygon" style="margin-top: 10px; text-align: center;">
        <a class="delete-polygon-link" (click)="onDeletePolygonClick(); $event.stopPropagation()" style="color: #d32f2f; cursor: pointer; ">
          <i class="fa fa-trash"></i> {{'POLYGON.DELETE_POLYGON' | translate}}
        </a>
      </div>


    </div>


    <div *ngIf="popupHoleActive()" id="popup-content">
      <h4 style="text-align: center;">
        {{ blastsNamePopup()?.length > 20 ? (blastsNamePopup() | slice: 0: 20) + '...' : blastsNamePopup() }}
      </h4>
    
      <div *ngIf="holePopup()">
        <p><strong>{{'HOLE.NAME' | translate}}:</strong> {{ holePopup()?.name }}</p>
        <p *ngIf="holePopup()?.plannedGeometry?.length"><strong>{{'HOLE.PLAN_DEPTH' | translate}}:</strong> {{ holePopup()?.plannedGeometry?.length | number: '1.0-2' }} m
        </p>
        <p *ngIf="holePopup()?.measuredGeometry?.length"><strong>{{'HOLE.MEASURED_DEPTH' | translate}}:</strong> {{ holePopup()?.measuredGeometry?.length | number: '1.0-2'
          }} m</p>
        <p *ngIf="holePopup()?.plannedGeometry?.diameter"><strong>{{'HOLE.DIAMETER' | translate}}:</strong> {{ holePopup()?.plannedGeometry?.diameter * 1000 | number:
          '1.0-2' }} mm</p>
      </div>
    
      <div *ngIf="holePopupDetails()?.Loading">
        <p *ngIf="holePopupDetails()?.Loading?.actualCharge?.totalBulk"><strong>{{'HOLE.MEASUREDBULK' | translate}}:</strong> {{ holePopupDetails()?.Loading?.actualCharge?.totalBulk |
          number: '1.0-2' }} kg</p>
        <p *ngIf="holePopupDetails()?.Loading?.actualCharge?.totalCartridges"><strong>{{'HOLE.MEASUREDCARTRIDGE' | translate}}:</strong> {{
          holePopupDetails()?.Loading?.actualCharge?.totalCartridges | number: '1.0-2' }}</p>
      </div>
    
      <div *ngIf="holePopup()?.status">
        <p><strong>{{'GLOBAL.STATUS' | translate}}:</strong> {{ 'HOLE.' + holePopup()?.status | translate }}</p>
      </div>
    
      <div class="popup-footer" style="text-align: left;">
        <a *ngIf="tirPopup()?.projetId"
          [routerLink]="['/mysite', utilService.currentSite()?.siteId, 'myprojects', tirPopup().projetId]"
          [queryParams]="{blastId: tirPopup().tirId}" title="{{'HOLE.DETAILS' | translate}}">
          {{'HOLE.DETAILS' | translate}}
        </a>
        <a class="create-polygon-btn" (click)="setActiveButton(3)">
          {{'POLYGON.CREATE_POLYGON' | translate}}
        </a>
      </div>
    </div>


    <div *ngIf="popupEquipmentActive()" id="popup-content">
      <h4 style="text-align: center;">{{equipmentDisplayName}}</h4>
      <p><strong>{{'GLOBAL.NOM' | translate}}: </strong> {{equipmentName}}</p>
      <p><strong>{{'GLOBAL.EXTERNAL_ID' | translate}}: </strong> {{equipmentExternalId}}</p>
      <p><strong>{{'DONNEE_SUIVI_OP.DATE' | translate}}: </strong> {{formattedDate}} {{formattedTime}}</p>
      <p><strong>{{'EPSG.LAT' | translate}}: </strong> {{equipmentLatitude}}</p>
      <p><strong>{{'EPSG.LONG' | translate}}: </strong> {{equipmentLongitude}}</p>
      
      <!-- Informations d'assignation -->
      <div style="border-top: 1px solid #ddd; padding-top: 10px; margin-top: 10px;">
        <!-- Si pas assigné : afficher message et bouton d'assignation -->
        <div *ngIf="!equipmentAssignedShift">
          <p style="color: #6c757d;">
            <strong>{{ 'DONNEE_SUIVI_OP.NOT_ASSIGNED' | translate }}</strong>
          </p>
          <div class="popup-footer" style="text-align: left;">
            <a class="create-polygon-btn" (click)="openAssignEquipmentModal()">
              {{ 'DONNEE_SUIVI_OP.ASSIGN_EQUIPMENT' | translate }}
            </a>
          </div>
        </div>
        
        <!-- Si assigné : afficher seulement le nom du blast et bouton de suppression -->
        <div *ngIf="equipmentAssignedShift">
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <p style="margin: 0;">
              <strong>{{ 'DONNEE_SUIVI_OP.ASSIGNED_TO_BLAST' | translate }}: </strong> 
              <span>{{ getBlastName(equipmentAssignedShift) }}</span>
            </p>
            <button type="button" 
                    class="btn" 
                    (click)="unassignEquipment()"
                    style="background: none; border: none; color: #dc3545; font-size: 18px; cursor: pointer; padding: 0; margin-left: 10px;"
                    title="{{ 'DONNEE_SUIVI_OP.UNASSIGN_EQUIPMENT' | translate }}">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Indicateur de mode d'assignation -->
    <div *ngIf="assignmentMode()" id="assignment-indicator" style="position: fixed; top: 20px; left: 50%; transform: translateX(-50%); z-index: 9999; background-color: #007bff; color: white; padding: 10px 20px; border-radius: 5px; box-shadow: 0 2px 10px rgba(0,0,0,0.3);">
      <div style="text-align: center;">
        <i class="fas fa-mouse-pointer" style="margin-right: 8px;"></i>
        <strong>{{ 'DONNEE_SUIVI_OP.SELECT_BLAST_MODE' | translate }}</strong>
      </div>
      <div style="font-size: 12px; margin-top: 4px; text-align: center;">
        {{ 'DONNEE_SUIVI_OP.CLICK_BLAST_POLYGON' | translate }}
      </div>
      <div style="text-align: center; margin-top: 8px;">
        <button class="btn btn-secondary btn-xs" (click)="cancelAssignmentMode()" style="font-size: 10px; padding: 2px 8px;">
          {{ 'GLOBAL.CANCEL' | translate }}
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="modalPolygoneTypeisVisible" class="modal-overlay-custome">
    <div class="modal-custome">
      <div class="modal-body">
        <label for="select">{{'POLYGON.SELECT_POLYGONE_TYPE' | translate}}:</label>
        <ng-select id="selectLangue" name="selectLangue" [(ngModel)]="selectedTirsPolygoneEnum" [clearable]="false"
          [searchable]="false">
          <ng-option [disabled]="i!=2" *ngFor="let option of optionsTirsPolygoneEnum; let i = index" [value]="option">{{
            option | translate}}</ng-option>
        </ng-select>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModalPolygoneType()">{{'GLOBAL.ANNULER' |
          translate}}</button>
      </div>
    </div>
  </div>
  <div *ngIf="modalValidationPrePolygoneisVisible" class="popup-model popup-min shadow center">
      <div class="d-flex justify-content-between align-items-center pink-header P-2">
        <h5 class="flex-grow-1 text-center mt-1">{{'POLYGON.POLYGON' | translate}}</h5>
        <div data-svg-wrapper style="position: relative" class="p-1">
          <button class="btn p-0 d-flex align-items-center" (click)="closeModalValidationPolygone()">
            <img src="assets/icon/close.svg" />
          </button>
        </div>
      </div>
      <div  class="p-4 pb-2 scrollable-container">
        <div class="row mb-3">
          <div class="col-md-12">
            <div class="form-group">
              <label for="blast-select">
                {{ preSelectedBlast ? ('POLYGON.CHANGE_BLAST' | translate) : ('POLYGON.SELECT_BLAST' | translate) }}:
              </label>
              
              <div *ngIf="preSelectedBlast" class="preselected-blast-info">
                <small class="text-muted">
                  {{ 'POLYGON.PRESELECTED' | translate }}: {{ preSelectedBlast.nom }}
                </small>
              </div>
              <div class="form-group input-select">
                <ng-select 
                  [(ngModel)]="selectedBlastForPolygon" 
                  bindLabel="nom"
                  bindValue="tirId"
                  [placeholder]="'POLYGON.SELECT_OR_CHANGE_BLAST' | translate"
                  [clearable]="false"
                  [appendTo]="'body'"
                  [dropdownPosition]="'auto'">
                  <ng-option *ngFor="let tir of listeTirs()" [value]="tir.tirId">
                    {{ tir.nom }}
                    <span *ngIf="preSelectedBlast && tir.tirId === preSelectedBlast.tirId" class="preselected-indicator">
                      ({{ 'POLYGON.PRESELECTED' | translate }})
                    </span>
                  </ng-option>
                </ng-select>
              </div>
            </div>
          </div>
          <div class="col-md-12 pt-2">
            <div class="form-group input-select">
              <label for="polygon-type-select" class="form-label">{{'POLYGON.SELECT_POLYGONE_TYPE' | translate}}:</label>
              <ng-select 
                [(ngModel)]="selectedTirsPolygoneEnum" 
                id="polygon-type-select"
                [placeholder]="'POLYGON.SELECT_TYPE_PLACEHOLDER' | translate"
                [clearable]="false"
                [searchable]="false"
                [appendTo]="'body'"
                [dropdownPosition]="'auto'">
                <ng-option [value]="PolyEnum.AUTOMATIC">{{ 'POLYGON.AUTOMATIC' | translate }}</ng-option>
                <ng-option [value]="PolyEnum.DRILLED">{{ 'POLYGON.DRILLED' | translate }}</ng-option>
                <ng-option [value]="PolyEnum.MUCKPILE">{{ 'POLYGON.MUCKPILE' | translate }}</ng-option>
                <ng-option [value]="PolyEnum.DANGER_ZONE">{{ 'POLYGON.DANGER_ZONE' | translate }}</ng-option>
              </ng-select>
            </div>
          </div>
          <div class="col-md-12 pt-3">
            <label for="select">{{'POLYGON.CONFIRM_CREATE_POLYGON' | translate}}</label>
          </div>
          <div class="d-flex justify-content-center pt-2" style="gap: 20px;">
            <button type="button" class="btn btn-outline-primary"
              (click)="closeModalValidationPolygone()">{{'GLOBAL.ANNULER' | translate}}</button>
            <button type="submit"
              class="btn primary-button ps-4 pe-4"
              (click)="savePolygone()"
              [disabled]="!selectedBlastForPolygon || !selectedTirsPolygoneEnum"
              >{{'GLOBAL.OUI' | translate}}</button>
          </div>
        </div>
      </div>
  </div>

  <!-- ZOI FORM MODAL -->
  <div *ngIf="zoiModalVisible" class="popup-model popup-min shadow center">
    <div class="d-flex justify-content-between align-items-center pink-header P-2">
      <h5 class="flex-grow-1 text-center mt-1">{{ 'ZOI.ZONE' | translate }}</h5>
      <div data-svg-wrapper style="position: relative" class="p-1">
        <button class="btn p-0 d-flex align-items-center" (click)="closeZoiModal()">
          <img src="assets/icon/close.svg" />
        </button>
      </div>
    </div>
    <div class="p-4 pb-2">
      <div class="form-group mb-3">
        <label>{{ 'ZOI.NAME' | translate }}</label>
        <input type="text" class="form-control" [(ngModel)]="zoiName" maxlength="100" autocomplete="off" />
      </div>
      <div class="form-group input-select mb-3">
        <label>{{ 'ZOI.TYPE' | translate }}</label>
        <ng-select [(ngModel)]="zoiType" [clearable]="false" [searchable]="false" [appendTo]="'body'">
          <ng-option [value]="0">{{ 'ZOI.CRUSHER' | translate }}</ng-option>
          <ng-option [value]="1">{{ 'ZOI.GARAGE' | translate }}</ng-option>
        </ng-select>
      </div>
      <div class="form-group mb-3">
        <label>{{ 'ZOI.THRESHOLD' | translate }}</label>
        <input type="number" class="form-control" [(ngModel)]="zoiThreshold" min="0" />
      </div>
      <div class="d-flex justify-content-center pt-2" style="gap: 20px;">
        <button type="button" class="btn btn-outline-primary" (click)="closeZoiModal()">{{ 'GLOBAL.ANNULER' | translate }}</button>
        <button type="button" class="btn primary-button ps-4 pe-4" (click)="saveZoneOfInterest()" [disabled]="!zoiName">{{ 'GLOBAL.VALIDER' | translate }}</button>
      </div>
    </div>
  </div>

@if (showPopupForm() && !isMapboxTerrainMode) {
<div id="popup-form" class="popup-form">
  <div class="popup-form-body">
    <div class="modal-body">
       <div class="header">
        <img src="assets/icon/icon-park_truck.svg" alt="" />
        <span class="title">Equipment</span>
      </div>

 <div class="filters-container">

  <!-- HEADER CLIQUABLE -->
  <div class="filters-header">
    <!-- Flèches de navigation côte à côte à gauche -->
    <div class="shift-nav-arrows">
      <i class="fa fa-chevron-left shift-nav-arrow"
         [class.disabled]="!canNavigateToPreviousShift()"
         (click)="navigateToPreviousShift(); $event.stopPropagation()">
      </i>
      <i class="fa fa-chevron-right shift-nav-arrow"
         [class.disabled]="!canNavigateToNextShift()"
         (click)="navigateToNextShift(); $event.stopPropagation()">
      </i>
    </div>

    <div class="filters-header-content" (click)="toggleDateRangePicker()">
      <img src="assets/icon/calendar.svg" alt="Calendar Icon" />

      <span class="time-display">
        {{ selectedDate() ? (selectedDate() | date:'dd/MM/yyyy') : 'No date selected' }}
      </span>

      <i class="fa"
         [ngClass]="isDateRangeExpanded() ? 'fa-chevron-up' : 'fa-chevron-down'">
      </i>
    </div>
  </div>

  <!-- CONTENU FILTRES AFFICHÉ UNIQUEMENT SI OUVERT -->
  @if (isDateRangeExpanded()) {
  <div class="filters-body">

    <!-- DATE -->
    <div class="filters">
      <div class="filter-input-wrapper">
        <i class="fa fa-calendar filter-input-icon"></i>
        <input
          type="text"
          placeholder="{{ 'GLOBAL.SELECT_TIME_PERIOD' | translate }}"
          [matDatepicker]="carteDatePicker"
          [ngModel]="selectedDate()"
          (ngModelChange)="selectedDate.set($event); onDateOrShiftChange()"
          name="date"
          [max]="today"
          (click)="carteDatePicker.open()"
          (focus)="carteDatePicker.open()"
          readonly
          required
          class="form-control date-input filter-styled-input"
        />
        <mat-datepicker #carteDatePicker></mat-datepicker>
        <i class="fa fa-chevron-down filter-input-chevron"></i>
      </div>
    </div>

    <!-- SHIFT -->
    <div class="filters">
      <div class="filter-input-wrapper">
        <i class="fa fa-clock filter-input-icon"></i>
        <ng-select
          id="shift"
          [ngModel]="selectedShift()"
          (ngModelChange)="selectedShift.set($event); onDateOrShiftChange()"
          name="shift"
          [placeholder]="'GLOBAL.SHIFT' | translate"
          [disabled]="timeSelection() === 'dateRange'"
          [required]="timeSelection() !== 'dateRange'"
          appendTo="body"
          class="filter-styled-select">

          @for (shift of shifts; track shift) {
            <ng-option [value]="shift">
              {{ formatShiftLabel(shift) | translate }}
            </ng-option>
          }
        </ng-select>
      </div>
    </div>

  </div>
  }
</div>


    <!-- SLIDER TEMPS -->
    @if (timeSliderEnabled()) {
    <div class="time-slider-and-filters-container">
      <div class="time-slider-container">
        <input
          type="range"
          class="time-slider"
          [min]="minTime()"
          [max]="maxTime()"
          [ngModel]="selectedTime()"
          (ngModelChange)="selectedTime.set($event); onTimeSliderChange()"
          (wheel)="onWheel($event)"
          [style.--slider-percentage.%]="getSliderPercentage()"
          step="1"
        />

        <div class="time-display">
          {{ formatTimeFromMinutes(selectedTime()) }}
          {{ formatTimeFromMinutes(minTime()) }} -
          {{ formatTimeFromMinutes(maxTime()) }}
        </div>
      </div>

      <!-- BOUTONS SPLIT ET ASSIGN -->
      <div class="action-buttons">
        <button type="button"
                class="btn-split"
                [class.active]="splitRouteMode()"
                (click)="toggleSplitRouteMode()">
          <i class="fa fa-scissors"></i>
          Split
        </button>
        <button type="button"
                class="btn-assign"
                [class.active]="assignmentMode()"
                (click)="toggleAssignmentMode()">
          <i class="fa fa-link"></i>
          Assign
        </button>
      </div>
    </div>
    }

    <!-- CHECKBOX ALL VIEW -->
    <label class="all-view">
      <input type="checkbox"
             #allViewCheckbox
             [checked]="allView()"
             (change)="onAllViewToggle()" />
      Tout (dé)sélectionner
    </label>
      @if (hasAppliedFilters() && equipmentsWithPositions() && equipmentsWithPositions().length > 0) {
      <div class="equipment-list">
        @for (item of equipmentsWithPositions(); track item.externalId) {
        <div
          class="equipment-card"
          [ngClass]="{ 'focused-card': item === focusedEquipment(), 'expanded': isEquipmentCardExpanded(item.externalId) }"
        >
          <div class="card-body">
            <input type="checkbox"
                   [checked]="isSelected(item)"
                   (click)="$event.stopPropagation()"
                   (change)="toggleSelection(item)"
                   class="equipment-checkbox" />
            <div class="card-header-content" (click)="toggleEquipmentCard(item.externalId)">
              <span class="type">{{ item.displayName }}</span>
              <i class="fa fa-chevron-down expand-icon"
                 [class.expanded]="isEquipmentCardExpanded(item.externalId)"></i>
            </div>
          </div>

          <!-- ROUTES -->
          @if (isEquipmentCardExpanded(item.externalId) && getRoutesForEquipment(item.externalId).length > 0) {
          <div class="routes-list">
            @for (route of getRoutesForEquipment(item.externalId); track route.dayKey + '_' + route.equipmentId) {
            <div
              class="route-item"
              (click)="onRouteCardClick(route)"
              draggable="true"
              (dragstart)="onRouteDragStart($event, route)"
              (dragend)="onRouteDragEnd($event)"
              [class.dragging]="draggingRoute() === route"
              [class.assigning]="routeToAssignByClick() === route"
              [class.selected-for-merge]="isRouteSelectedForMerge(route)">
              <!-- Ligne 1: checkbox + carré couleur + Route date + bouton merge -->
              <div class="route-row">
                <input type="checkbox"
                       [checked]="route.isSelected"
                       (click)="$event.stopPropagation()"
                       (change)="selectRoute(route)"
                       class="route-checkbox" />
                <div class="route-color-square" [style.background-color]="route.color"></div>
                <span class="route-label">Route {{ formatRouteDate(route.dayKey) }}</span>
                <button type="button" class="route-merge-btn"
                        (click)="toggleRouteForMerge(route, $event)"
                        [class.active]="isRouteSelectedForMerge(route)"
                        title="{{ isRouteSelectedForMerge(route) ? 'Annuler la fusion' : (routeSelectedForMerge() ? 'Fusionner avec la route sélectionnée' : 'Sélectionner pour fusion') }}">
                  <i class="fa fa-compress"></i>
                </button>
                <button class="route-zoom-btn"
                        (click)="zoomToRoute(route); $event.stopPropagation()"
                        title="Recentrer sur la route">
                  <i class="fa fa-crosshairs"></i>
                </button>
              </div>
              <!-- Ligne 2: espaces vides + heure -->
              <div class="route-row">
                <div class="route-spacer"></div>
                <div class="route-spacer"></div>
                <span class="route-time">{{ formatRouteTime(route.startTime) }}-{{ formatRouteTime(route.endTime) }}</span>
              </div>
              <!-- Ligne 3: espace + check + blast name + poubelle -->
              @if (route.tirId) {
              <div class="route-row">
                <div class="route-spacer"></div>
                <i class="fa fa-check route-check-icon"></i>
                <span class="route-blast-name">{{ getBlastNameById(route.tirId) }}</span>
                <button class="route-unassign-btn"
                        (click)="unassignRouteFromBlast(route); $event.stopPropagation()"
                        title="Désassigner du blast">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
              }
            </div>
            }
          </div>
          }
        </div>
        }
    </div>
    }
  </div>
</div>
</div>
}


<!-- Modal de confirmation suppression orthophoto -->
<div bsModal #modalConfirmDeleteOrtho="bs-modal" class="modal fade modal-ok-delete" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{ backdrop: 'static' }">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body text-center">
        <p>{{ "GLOBAL.CONFIRMATION_SUPPRESSION" | translate }}</p>
        <p *ngIf="orthoToDelete" style="font-weight: bold; margin-top: 10px;">
          {{ orthoToDelete.mapName }}
        </p>
        
        <button type="button" class="btn btn-primary" (click)="confirmDeleteOrthoLayer()">
          {{ "GLOBAL.OUI" | translate }}
        </button>
        
        <button type="button" class="btn btn-secondary" (click)="cancelDeleteOrthoLayer()" style="margin-left: 20px">
          {{ "GLOBAL.NON" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de confirmation suppression polygone (ngx-bootstrap) -->
<div bsModal #modalConfirmDeletePolygon="bs-modal" class="modal fade modal-ok-delete" tabindex="-1" role="dialog" aria-labelledby="dialog-delete-polygon" [config]="{ backdrop: 'static' }">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body text-center">
  <p>{{ 'GLOBAL.CONFIRM_DELETE_POLYGON' | translate }}</p>
  <p style="font-weight: bold; margin-top: 10px;" *ngIf="tirPopup()">{{ tirPopup().nom }}</p>
  <button type="button" class="btn btn-primary" (click)="confirmDeletePolygon()">{{ 'GLOBAL.OUI' | translate }}</button>
  <button type="button" class="btn btn-secondary" (click)="cancelDeletePolygon()" style="margin-left: 20px">{{ 'GLOBAL.NON' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<!-- Slider temporel des tirs en mode 3D -->
@if (isMapboxTerrainMode) {
<div style="position:fixed;bottom:20px;left:50%;transform:translateX(-50%);z-index:99999;background:rgba(255,255,255,0.95);padding:15px 25px;border-radius:12px;box-shadow:0 4px 20px rgba(0,0,0,0.2);min-width:400px;">
  <div style="display:flex;align-items:center;gap:8px;margin-bottom:8px;font-size:13px;font-weight:600;color:#6C1D45;">
    <i class="fas fa-clock"></i>
    <span>{{ visibleBlastCount() }} / {{ selectedBlastIdsSignal().length || sortedBlasts().length }} tirs</span>
  </div>
  <!-- Les bornes viennent de filteredSortedBlasts : se baser sur sortedBlasts
       affichait un slider sans course quand la sélection n'a aucun tir daté -->
  @if (filteredSortedBlasts().length > 0) {
  <input type="range" style="width:100%;"
    [min]="timelineMin()" [max]="timelineMax()"
    [ngModel]="timelineCursor()" (ngModelChange)="onTimelineCursorChange($event)"
    (wheel)="onTimelineWheel($event)"
    step="86400000" />
  <div style="display:flex;justify-content:space-between;font-size:11px;color:#666;margin-top:4px;">
    <span>{{ timelineMin() | date:'dd/MM/yyyy' }}</span>
    <span style="font-weight:600;color:#333;">{{ timelineCursor() | date:'dd/MM/yyyy' }}</span>
    <span>{{ timelineMax() | date:'dd/MM/yyyy' }}</span>
  </div>
  }
  <div style="display:flex;gap:12px;margin-top:10px;padding-top:8px;border-top:1px solid #eee;font-size:12px;">
    <label style="display:flex;align-items:center;gap:4px;cursor:pointer;">
      <input type="checkbox" [ngModel]="showSiteTerrain()" (ngModelChange)="showSiteTerrain.set($event); onLayerToggle()">
      Terrain site
    </label>
    <label style="display:flex;align-items:center;gap:4px;cursor:pointer;">
      <input type="checkbox" [ngModel]="showBlastTerrains()" (ngModelChange)="showBlastTerrains.set($event); onLayerToggle()">
      Terrains blast
    </label>
    <label style="display:flex;align-items:center;gap:4px;cursor:pointer;">
      <input type="checkbox" [ngModel]="showHoles3D()" (ngModelChange)="showHoles3D.set($event); onLayerToggle()">
      Trous
    </label>
  </div>
  <div style="display:flex;align-items:center;gap:8px;margin-top:6px;font-size:12px;">
    <span>Opacité</span>
    <input type="range" min="0" max="1" step="0.05"
           [ngModel]="terrainOpacity()"
           (ngModelChange)="onTerrainOpacityChange($event)"
           style="flex:1;cursor:pointer;" />
    <span style="min-width:32px;text-align:right;">{{ (terrainOpacity() * 100) | number:'1.0-0' }}%</span>
  </div>
</div>
}

